import { LocalizedLink } from "@/i18n/language";
import { useTranslation } from "react-i18next";
import { img } from "@/lib/images";

export default function BausteineSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="relative h-[600px] md:h-[720px] lg:h-[780px] w-full">
        <img
          src={img("home/home-your-stay-01.jpg")}
          alt="Bali VW Tour – Ihren Aufenthalt als Baustein planen"
          title="Bali VW Tour – Ihren Aufenthalt als Baustein planen"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/45 to-black/15"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-black/20"></div>

        <div className="absolute inset-0 z-10 flex items-center">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
            <div className="max-w-2xl">
              <div className="mb-6 eyebrow-brand text-xs md:text-sm font-medium tracking-[0.45em] uppercase">
                — {t("baustein_section_eyebrow")} —
              </div>
              <h2 className="font-heading text-background-50 text-3xl md:text-5xl lg:text-6xl font-semibold leading-[1.08] tracking-tight mb-7">
                {t("baustein_section_title")}
              </h2>
              <p className="text-background-100 text-lg md:text-xl font-light leading-relaxed mb-9 max-w-xl">
                {t("baustein_section_desc")}
              </p>
              <LocalizedLink
                to="/your-stay"
                className="flex w-full sm:inline-flex sm:w-auto items-center justify-center gap-2 border border-background-50/70 text-background-50 hover:border-primary-500 hover:bg-primary-600/20 px-6 md:px-8 py-3.5 rounded-md font-semibold uppercase tracking-[0.12em] md:tracking-[0.2em] text-center leading-snug cursor-pointer transition-colors text-xs sm:text-sm max-w-xl"
              >
                {t("baustein_section_cta")}
                <i className="ri-arrow-right-line flex-shrink-0"></i>
              </LocalizedLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}